module.exports = __webpack_public_path__ + "img/art_4_6.c3cf52aa.jpeg";